module.exports = __webpack_public_path__ + "static/img/lauren.9b363b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff-images/lauren.png
// module id = X1dW
// module chunks = 0